import { $fetch } from 'ofetch';

export const getStates = async () => {
  const STATE = {
    error: true,
    success: false,
  };

  const statesList = {
    list: [],
  };
  await $fetch('https://data.shiftkey.com/v1/job-listings/states', {
    headers: {
      'x-api-key': useRuntimeConfig()?.public?.jobBoardAPIKey,
    },
  })
    .then((response) => {
      console.log('response', response);
      if (response.length === 0) {
        STATE.error = true;
        STATE.success = false;
        console.log('no states');
        statesList.list = [];
      } else {
        console.log('got states');
        STATE.error = false;
        STATE.success = true;
        statesList.list = response.map(
          (state: { [key: string]: string }) => Object.values(state)[0]
        );
      }
    })
    .catch((error) => {
      STATE.error = true;
      STATE.success = false;
      console.error('Error fetching states:', error.message || error);
      statesList.list = [];
    });

  return statesList.list;
};

export const getCities = async (state: string) => {
  const STATE = {
    error: true,
    success: false,
  };

  const citiesList = {
    list: [],
  };
  await $fetch('https://data.shiftkey.com/v1/job-listings/cities', {
    headers: {
      'x-api-key': useRuntimeConfig()?.public?.jobBoardAPIKey,
    },
    query: {
      state,
    },
  })
    .then((response) => {
      console.log('response', response);
      if (response.length === 0) {
        STATE.error = true;
        STATE.success = false;
        console.log('no cities');
        citiesList.list = [];
      } else {
        console.log('got cities');
        STATE.error = false;
        STATE.success = true;
        citiesList.list = response.map(
          (state: { [key: string]: string }) => Object.values(state)[0]
        );
        // Remove duplicates
        citiesList.list = [...new Set(citiesList.list)];
      }
    })
    .catch((error) => {
      STATE.error = true;
      STATE.success = false;
      console.error('Error fetching cities:', error.message || error);
      citiesList.list = [];
    });

  return citiesList.list;
};

export const getJobs = async (
  stateName: string,
  cityName: string,
  jobName?: string
) => {
  const STATE = {
    error: true,
    success: false,
  };

  const jobsList = {
    array: [],
  };
  const query: { [key: string]: string | undefined } = {
    state: stateName,
    city: cityName,
  };

  if (jobName) {
    query.job_role = jobName;
  }

  await $fetch('https://data.shiftkey.com/v1/job-listings', {
    headers: {
      'x-api-key': useRuntimeConfig()?.public?.jobBoardAPIKey,
    },
    query,
  })
    .then((response) => {
      console.log('response', response);
      if (response.length === 0) {
        STATE.error = true;
        STATE.success = false;
        console.log('no Jobs');
        jobsList.array = [];
      } else {
        console.log('got jobs');
        STATE.error = false;
        STATE.success = true;
        jobsList.array = response;
      }
    })
    .catch((error) => {
      STATE.error = true;
      STATE.success = false;
      console.error('Error fetching cities:', error.message || error);
      jobsList.array = [];
    });

  return jobsList.array;
};
